import React, { useState } from "react";

import BillingLinkButton from "@app/analytics/account/Billing/components/BillingLinkButton";
import useBillingSubscription from "@app/analytics/hooks/billing/useBillingSubscription";
import * as Events from "@app/analytics/tracking/events";
import { toast } from "@app/common/hooks/useToasts";

import DowngradeModal from "./DowngradeModal";

const CancelPlanButton = () => {
  const [downgradeModalOpen, setDowngradeModalOpen] = useState(false);
  const { cancelSubscription } = useBillingSubscription();

  const handleConfirmCancelSubscription = () => {
    Events.cancelPlan();
    cancelSubscription.mutate(undefined, {
      onSuccess: () => {
        toast.success("Your Read plan has been successfully cancelled.");
      },
      onError: () => {
        toast.error(
          "Something went wrong and your plan could not be cancelled. Please try again or reach out to support@read.ai if the problem persists."
        );
      },
    });
    setDowngradeModalOpen(false);
  };

  return (
    <>
      <DowngradeModal
        open={downgradeModalOpen}
        onClose={() => setDowngradeModalOpen(false)}
        onConfirm={handleConfirmCancelSubscription}
      />
      <BillingLinkButton
        color="error"
        testId="billing-cancel-plan"
        variant="text"
        onClick={() => setDowngradeModalOpen(true)}
      >
        Cancel plan
      </BillingLinkButton>
    </>
  );
};

export default CancelPlanButton;
